var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarcerrar52X48(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28C41.2548 0 52 10.7452 52 24V24C52 37.2548 41.2548 48 28 48H0V0Z",
    fill: "#69C4DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0484 24.2929C23.9039 24.1243 23.9039 23.8757 24.0484 23.7072L29.379 17.4881C29.6486 17.1736 29.6121 16.7001 29.2977 16.4306C28.9832 16.161 28.5097 16.1974 28.2401 16.5119L22.9095 22.731C22.2836 23.4612 22.2836 24.5388 22.9095 25.2691L28.2401 31.4881C28.5097 31.8026 28.9832 31.839 29.2976 31.5695C29.6121 31.2999 29.6486 30.8264 29.379 30.5119L24.0484 24.2929Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarcerrar52X48);
export default __webpack_public_path__ + "static/media/SIDEBAR CERRAR_52X48.fd335c6a75c68f964d6440555b690bd9.svg";
export { ForwardRef as ReactComponent };